import axios from 'utils/axios';
import { AxiosResponse } from 'axios';

export const setAutoPaymentApi = (patientServicePackageId: string, isAutoPayment: boolean): Promise<AxiosResponse> =>
  axios.put(`/api/v1/servicepackages/my/autopayment/${patientServicePackageId}`, { isAutoPayment });

export const getServicePackageGroups = (params: { query?: string; deleted?: boolean }): Promise<AxiosResponse> =>
  axios.get(`/api/v1/servicepackagegroups`, { params });
